/* ============================================================
   REGINA – Wissensbank: Live-Suche über echte Blogartikel
   assets/knowledge-base.js
   ------------------------------------------------------------
   Nutzt Shopifys Predictive-Search-API: durchsucht AUTOMATISCH
   alle Blogartikel (Titel + Inhalt) – ohne Handpflege. Sobald
   du einen Artikel schreibst, ist er hier sofort auffindbar.

   Beim Tippen:
   1. LIVE-SCHUBLADE zeigt echte Artikel mit Textpassage, in der
      der Suchbegriff honig-gelb markiert ist.
   2. HONIG-HIGHLIGHT: kuratierte Kacheln, deren Titel/Begriffe
      passen, glühen weiter golden auf (Symbiose).
   3. Tastatur-Navigation (Pfeile/Enter/Escape).
   ============================================================ */
(function () {
  if (window.__kbInit) return;
  window.__kbInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeReg(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function stripTags(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  }

  ready(function () {
    var input = document.querySelector('[data-kb-search]');
    if (!input) return;

    var results = document.querySelector('[data-kb-results]');
    var status = document.querySelector('[data-kb-status]');
    var form = input.closest('form');

    // Kuratierte Kacheln (für das Honig-Aufglühen – NICHT die Suchquelle)
    var tiles = Array.prototype.slice.call(document.querySelectorAll('[data-kb-item]')).map(function (el) {
      return {
        el: el,
        title: (el.dataset.kbTitle || '').toLowerCase(),
        terms: (el.dataset.kbTerms || '').toLowerCase()
      };
    });

    var debounce = null;
    var current = [];       // aktuelle Artikel-Treffer
    var activeIdx = -1;
    var lastQuery = '';
    var cache = {};         // einfache Query->Ergebnis-Zwischenspeicherung

    /* ---------- Passage aus Artikeltext ziehen + markieren ---------- */
    function buildPassage(text, q) {
      if (!text) return '';
      var lc = text.toLowerCase();
      var pos = lc.indexOf(q.toLowerCase());
      if (pos === -1) return escapeHtml(text.slice(0, 150)) + (text.length > 150 ? '…' : '');
      var start = pos, end = pos + q.length;
      while (start > 0 && !/[.!?]/.test(text[start - 1])) start--;
      while (end < text.length && !/[.!?]/.test(text[end])) end++;
      if (end < text.length) end++;
      var sentence = text.slice(start, end).trim();
      if (sentence.length > 190) {
        var rel = pos - start;
        var from = Math.max(0, rel - 75);
        sentence = (from > 0 ? '…' : '') + sentence.slice(from, from + 184) + '…';
      }
      var safe = escapeHtml(sentence);
      var re = new RegExp('(' + escapeReg(q) + ')', 'ig');
      return safe.replace(re, '<mark>$1</mark>');
    }

    /* ---------- Honig-Aufglühen der kuratierten Kacheln ---------- */
    function highlightTiles(q) {
      var lc = q.toLowerCase();
      tiles.forEach(function (t) {
        var match = lc.length >= 2 && (t.title.indexOf(lc) !== -1 || t.terms.indexOf(lc) !== -1);
        t.el.classList.toggle('kb-match', match);
        t.el.classList.toggle('kb-dim', lc.length >= 2 && !match);
      });
    }
    function clearTiles() {
      tiles.forEach(function (t) { t.el.classList.remove('kb-match', 'kb-dim'); });
    }

    function closeDrawer() {
      if (results) { results.classList.remove('is-open'); results.innerHTML = ''; }
      input.setAttribute('aria-expanded', 'false');
      activeIdx = -1;
    }
    function reset() {
      clearTiles(); closeDrawer();
      if (status) { status.innerHTML = ''; status.classList.remove('kb-status-visible'); }
      current = [];
    }

    function renderDrawer(q) {
      if (!results) return;
      if (!current.length) {
        var shopSearch = '/search?q=' + encodeURIComponent(q) + '&type=article';
        results.innerHTML =
          '<div class="kb-result-empty">Noch kein Artikel dazu gefunden – ' +
          '<a href="' + shopSearch + '">im ganzen Shop suchen →</a></div>';
        results.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
        return;
      }
      var html = current.map(function (hit, i) {
        return '' +
          '<a class="kb-result' + (i === activeIdx ? ' is-active' : '') + '" href="' + hit.url + '" role="option" id="kb-result-' + i + '" aria-selected="' + (i === activeIdx ? 'true' : 'false') + '" data-kb-result="' + i + '">' +
            '<span class="kb-result-head">' +
              '<span class="kb-result-title">' + escapeHtml(hit.title) + '</span>' +
              (hit.cat ? '<span class="kb-result-cat">' + escapeHtml(hit.cat) + '</span>' : '') +
            '</span>' +
            '<span class="kb-result-snippet">' + hit.passage + '</span>' +
          '</a>';
      }).join('');
      results.innerHTML = html + '<div class="kb-result-foot">↑↓ blättern · ↵ öffnen</div>';
      results.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    function setStatus(n) {
      if (!status) return;
      status.classList.add('kb-status-visible');
      if (n > 0) status.innerHTML = '<strong>' + n + '</strong> ' + (n === 1 ? 'Artikel' : 'Artikel') + ' gefunden';
      else status.innerHTML = 'Noch kein Artikel dazu.';
    }

    /* ---------- Shopify Predictive Search abfragen ---------- */
    function fetchArticles(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=article&resources[limit]=6' +
                '&resources[options][unavailable_products]=hide' +
                '&resources[options][fields]=title,body,author,tag';
      return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var arts = (data.resources && data.resources.results && data.resources.results.articles) || [];
          return arts.map(function (a) {
            var text = stripTags(a.body || a.summary_html || a.content || '');
            return {
              title: a.title || '',
              url: a.url || '#',
              cat: (a.blog && a.blog.title) ? a.blog.title : 'Wissen',
              passage: buildPassage(text, q)
            };
          });
        });
    }

    function run(qRaw) {
      var q = qRaw.trim();
      if (q.length < 2) { reset(); return; }
      lastQuery = q;
      highlightTiles(q);

      if (cache[q]) { applyResults(q, cache[q]); return; }

      fetchArticles(q).then(function (arts) {
        cache[q] = arts;
        if (q !== lastQuery) return; // veraltete Antwort verwerfen
        applyResults(q, arts);
      }).catch(function () {
        if (q !== lastQuery) return;
        current = []; activeIdx = -1; renderDrawer(q);
        if (status) { status.classList.add('kb-status-visible'); status.innerHTML = 'Suche gerade nicht verfügbar.'; }
      });
    }

    function applyResults(q, arts) {
      current = arts; activeIdx = -1;
      renderDrawer(q);
      setStatus(arts.length);
    }

    input.addEventListener('input', function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () { run(input.value); }, 180);
    });
    var root = document.documentElement;

    // "Aktiv" = Suchfeld hat Fokus ODER enthält Text. Im aktiven Zustand
    // blenden Kategorien-Karte + Chips weg (via Klasse am <html>), die
    // Suche tritt in den Vordergrund.
    function setActive(on) {
      root.classList.toggle('kb-searching', on);
    }
    function syncActive() {
      var hasText = input.value.trim().length > 0;
      var hasFocus = document.activeElement === input;
      setActive(hasText || hasFocus);
    }

    input.addEventListener('focus', function () {
      setActive(true);
      if (current.length && input.value.trim().length >= 2) renderDrawer(input.value.trim());
    });
    input.addEventListener('blur', function () {
      // kurz warten: Klick auf ein Ergebnis/Chip soll nicht sofort abbrechen
      setTimeout(syncActive, 120);
    });

    input.addEventListener('keydown', function (e) {
      if (!results || !results.classList.contains('is-open')) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, current.length - 1); renderDrawer(input.value.trim()); scrollActive(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, 0); renderDrawer(input.value.trim()); scrollActive(); }
      else if (e.key === 'Escape') { closeDrawer(); }
    });
    function scrollActive() {
      var el = results.querySelector('.kb-result.is-active');
      if (el) {
        el.scrollIntoView({ block: 'nearest' });
        input.setAttribute('aria-activedescendant', el.id || '');
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        var q = input.value.trim();
        if (q.length < 2) { e.preventDefault(); return; }
        var target = null;
        if (activeIdx >= 0 && current[activeIdx]) target = current[activeIdx].url;
        else if (current.length) target = current[0].url;
        if (target && target !== '#') { e.preventDefault(); window.location.href = target; }
        // sonst: Formular geht an die echte Shop-Suche
      });
    }

    document.querySelectorAll('[data-kb-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.dataset.kbChip;
        setActive(true);
        input.focus();
        run(input.value);
      });
    });

    document.addEventListener('click', function (e) {
      if (form && !form.contains(e.target)) {
        // Klick auf eine Kachel im Ruhezustand -> als Sucheingabe nutzen
        var tile = e.target.closest ? e.target.closest('[data-kb-item]') : null;
        if (tile && !root.classList.contains('kb-searching')) {
          e.preventDefault();
          var term = tile.dataset.kbSearchterm || tile.dataset.kbTitle || '';
          input.value = term;
          setActive(true);
          input.focus();
          run(term);
          return;
        }
        closeDrawer();
        syncActive();
      }
    });
  });
})();
